import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import MomentPropTypes from 'react-moment-proptypes';
import CardSectionHeading from '../CardSectionHeading';
import CardRowKeyVal from '../CardRowKeyVal';
import moment from 'moment-timezone';
import get from 'lodash/get';

const propTypes = {
  beneficiaries: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    }),
  ),
  details: PropTypes.shape({
    airline_name: PropTypes.string,
    airline_code: PropTypes.string,
    departed: MomentPropTypes.momentString,
    pax_name: PropTypes.string,
  }),
  plan: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
};

const defaultProps = {
  details: {},
  plan: {},
};

class PolicyDetailsFlight extends PureComponent {
  render() {
    const {
      beneficiaries,
      details,
      plan,
    } = this.props;
    const departMoment = moment(details.departed);
    const departWord = moment().isAfter(departMoment) ? 'Departed' : 'Departing';

    return (
      <div>
        <CardSectionHeading>
          Flight Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Airline"
          detail={`${details.airline_name} (${details.airline_code})`}
        />
        <CardRowKeyVal
          title={departWord}
          detail={departMoment.format(`[${departWord}] MMM D, YYYY [at] hh:mm A`)}
        />
        <CardRowKeyVal
          title="Passenger"
          detail={details.pax_name}
        />
        <CardSectionHeading>
          Beneficiary Details
        </CardSectionHeading>
        <CardRowKeyVal
          title="Primary Beneficiary"
          detail={get(beneficiaries, '[0].name')}
        />
        <CardSectionHeading>
          Policy Selections
        </CardSectionHeading>
        <CardRowKeyVal
          title="Plan type"
          detail={plan.title}
        />
        <CardRowKeyVal
          title="Coverage"
          detail={plan.subtitle}
        />
      </div>
    );
  }
}

PolicyDetailsFlight.propTypes = propTypes;
PolicyDetailsFlight.defaultProps = defaultProps;

export default PolicyDetailsFlight;
